import React from 'react';
import './DeferrableSavingComponent.css';

interface DeferrableSavingComponentProps {
  children: React.ReactNode;
}

// Wraps the tabs saved with the version; their Save button is in the editor's top bar
const DeferrableSavingComponent: React.FC<DeferrableSavingComponentProps> = ({ children }) => {
  return (
    <div className="deferrable-saving-component">
      {children}
    </div>
  );
};

export default DeferrableSavingComponent;
